import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { ItemServico } from '../api/dto/item-servico';
import { ItemServicoCustoMaterial } from '../api/dto/item-servico-custo-material';
import { Paginador } from '../api/dto/paginacao/paginador';
import { MensagemChamado } from '../api/dto/mensagem-chamado';

@Injectable({
    providedIn: 'root',
})
export class MensagemChamadoService {

    constructor(private http: HttpClient) { }

    private url : string = UrlServidor.URL_BASE + 'mensagens-chamado';

    buscarPorId(id?: number): Observable<MensagemChamado> {
        return this.http.get<MensagemChamado>(`${this.url}/${id}`);
    }

    listarPoChamadoId(id?: number): Observable<MensagemChamado[]> {
        return this.http.get<MensagemChamado[]>(`${this.url}/chamado/${id}`);
    }

    listarBaseConhecimentoPorChamadoId(id?: number): Observable<MensagemChamado[]> {
        return this.http.get<MensagemChamado[]>(`${this.url}/chamado/${id}/base-conhecimento`);
    }

    listarBaseConhecimentoPorAdministradoraId(administradoraId?: number, numeroPagina?: number, tamanhoPagina?: number,
         ordenacao?: string, inputBusca?: string, tipoAtendimento?: string): Observable<Paginador<MensagemChamado>> {

        let params = new HttpParams();
        if(tamanhoPagina) {
            params = params.set('tamanho', tamanhoPagina);
        }
        if(ordenacao) {
            params = params.set('sort', ordenacao);
        }
        if(inputBusca) {
            params = params.set('busca', inputBusca);
        }
        if(tipoAtendimento) {
            params = params.set('tipo', tipoAtendimento);
        }

        return this.http.get<Paginador<MensagemChamado>>(`${this.url}/administradora/${administradoraId}/base-conhecimento/pagina/${numeroPagina}`, {params});
    }

    salvar(mensagemChamado?: MensagemChamado): Observable<MensagemChamado> {
        return this.http.post<MensagemChamado>(this.url, mensagemChamado);
    }

    salvarListaMensagensAnexadas(listaMensagens?: MensagemChamado[]): Observable<void> {
        return this.http.post<void>(this.url + '/anexos', listaMensagens);
    }
    
}

